import { Paginated } from 'src/app/shared/paginated.model';
import { CRMUserMapping, Integration, IntegrationPlatform } from 'voxloud-types/dist/models/integrations/index';

export interface UIIntegration extends Integration {
  _isLoading: boolean;
}

export interface PlatformsResponse extends Paginated<IntegrationPlatform> {
}

export enum CUSTOM_FIELDS_NAME {
  CHANNEL_ID = 'channels',
  DEPARTMENT_ID = 'departments',
  WORK_TYPE_ID = 'work_types'
}

export interface SetupDataValues {
  id: string;
  name: string;
}

export interface CRMUserMappings {
  user_mappings: CRMUserMapping[];
}